import React, { useEffect } from "react"
import NewBusinessIcon from "../../images/business/new-business.svg"
import axios from "axios"
import TinIcon from "../../images/business/new-tin.svg"
import CompanyIcorp from "../../images/business/company-incor.svg"

import TitleText from "./TitleText"
import BusinessTitleCard from "./BusinessCardTitle"

const business_options = [
  {
    icon: NewBusinessIcon,
    title: "Register a new business",
    desc: "Officially register your business, get CAC and a tax identification number.",
    link: "/business-support/business-registration",
  },
  {
    icon: TinIcon,
    title: "New TIN",
    desc: "Apply for a new Tax identification number (TIN).",
    link: "/business-support/tin-application",
  },
  {
    icon: CompanyIcorp,
    title: "Company incorporation",
    desc: "Officially register your company or in corporation, get CAC and a TIN",
    link: "/business-support/company-incorporation",
  },
  // {
  //   icon: TinIcon,
  //   title: "Update your TIN",
  //   desc: "Apply for correction or to make edits to your Tax identification number",
  //   link: "",
  // },
]

const GetStarted = () => {
  useEffect(() => {
    axios(
      `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/business/support-rates`
    )
      .then((res) => {
        localStorage.setItem("supportFees", JSON.stringify(res.data.data.fees))
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])
  return (
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <TitleText />
        <div className="">
          <div className="row justify-content-center">
            {business_options.map((opt) => (
              <BusinessTitleCard
                icon={opt.icon}
                title={opt.title}
                subtitle={opt.desc}
                link={opt.link}
                key={opt.title}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GetStarted
